import { Theme } from "@mui/material/styles";
import LimeImageLight from "../assets/lime_logo_light.png";
import LimeImageWhite from "../assets/lime_logo_white.png";
import { isMobile } from "react-device-detect";
import { colors } from "../constants/styleConstants";

interface IHeaderProps {
  disableMenu?: boolean;
  onMenuClick?: () => void;
}

export const Header = ({ disableMenu = false, onMenuClick }: IHeaderProps) => {

  return (
    <header
      className={`${'content'} ${disableMenu && 'justify-center'}`}
    >
      {!disableMenu && (
        <button className={'menu'} onClick={onMenuClick}>
          <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.5 27H31.5V24H4.5V27ZM4.5 19.5H31.5V16.5H4.5V19.5ZM4.5 9V12H31.5V9H4.5Z" fill="white"/>
          </svg>
        </button>
      )}
      <img
        src={isMobile ? LimeImageWhite : LimeImageLight}
        alt="Lime Logo Light"
        className={`${'logo-image'} ${disableMenu && 'no-margin'}`}
      />
    </header>
  );
};

export default Header;
